<template>
  <div>
    <v-alert
      v-if="!loading && reviewsPackage.type == 'trial'"
      type="info"
      icon="timelapse"
      class="py-0 mb-4"
      mb-4
      prominent
      text
      dense
    >
      <v-row align="center">
        <v-col class="grow"
          ><strong>Proefperiode</strong> van Reviews is actief voor
          {{ activeCompData.name }}.
        </v-col>
        <v-col class="shrink">
          <v-btn color="info" outlined>
            Nog {{ reviewsPackage.days }}
            <span style="color: #2196f3" v-if="reviewsPackage.days == 1"
              >dag</span
            ><span style="color: #2196f3" v-else>dagen</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-alert>

    <div v-if="loading" class="blackbox-loader"></div>

    <v-container
      v-if="!loading && companies.length > 1"
      grid-list-md
      class="pa-0 pt-2"
      fluid
    >
      <v-layout row wrap class="mb-2">
        <v-flex md3 xs12>
          <v-select
            v-if="!loading && companies.length > 1 && !demoMode"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            item-text="name"
            item-value="id"
            v-on:input="loadActiveCompData()"
            v-model="activeComp"
            hide-details
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            dense
          >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content class="pt-0">
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    prepend-inner-icon="search"
                    clearable
                    v-model="searchCompanies"
                    hide-details=""
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div
                v-if="searchCompanies && searchCompanies.length > 0"
                style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px"
              >
                {{ filteredCompanies.length }} van
                {{ companies.length }} bedrijven
              </div>
              <v-divider
                v-if="searchCompanies && searchCompanies.length > 0"
              ></v-divider>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>

    <v-card outlined v-if="!loading">
      <v-card-text>
        <v-container grid-list-md class="pa-0" fluid>
          <v-layout row wrap>
            <v-flex md6 xs12>
              <h1 class="tab-title">Digitale bon instellingen</h1>
              <p class="ma-0">
                Personaliseer de teksten die de respondenten te zien kijken in
                de email die verzonden wordt.
              </p>
            </v-flex>
            <v-flex md6 xs12>
              <div style="display: inline-block; float: right;">
                <v-btn
                  rounded
                  :color="companySecondaryColor"
                  class="modal-button-next"
                  :dark="changed"
                  :disabled="!changed"
                  :depressed="!changed"
                  @click="updateReceiptEmail()"
                  >Wijzigingen opslaan<v-icon right dark
                    >chevron_right</v-icon
                  ></v-btn
                >
              </div>
            </v-flex>
          </v-layout>

          <v-layout row class="mb-5">
            <v-flex xs6>
              <v-btn
                depressed
                dark
                :color="companySecondaryColor"
                @click="resendReceiptData.dialog = true"
                >Bon opnieuw verzenden</v-btn
              >
            </v-flex>
            <v-flex xs6>
              <v-btn
                depressed
                style="float: right;"
                dark
                outlined
                :color="companySecondaryColor"
                @click="
                  (receiptMarketingData.dialog = true),
                    (receiptMarketingData.edit = false)
                "
                >Promotie toevoegen</v-btn
              >
            </v-flex>
          </v-layout>

          <v-text-field
            outlined
            :color="companyPrimaryColor"
            label="Onderwerp"
            v-model.trim="activeCompData.receipt.subjectDefaultInvoice"
            counter="65"
            maxlength="65"
          ></v-text-field>

          <div class="email-preview-wrapper">
            <v-alert
              class="ma-0 pa-2"
              v-if="feedback.show"
              :value="true"
              :type="feedback.type"
            >
              {{ feedback.message }}
            </v-alert>
            <div
              class="email-preview"
              :style="{
                backgroundColor: $vuetify.theme.themes[theme].background,
              }"
            >
              <div
                class="email-wrapper"
                :style="{
                  backgroundColor: $vuetify.theme.themes[theme].menu,
                  borderColor: $vuetify.theme.themes[theme].menuborder,
                }"
              >
                <div class="email-logo">
                  <img :src="activeCompData.logoUrl" />
                </div>

                <v-tabs
                  v-if="activeCompData.receipt"
                  color="white"
                  :slider-color="companyPrimaryColor"
                >
                  <v-tab ripple>
                    Mannen
                  </v-tab>
                  <v-tab ripple>
                    Vrouwen
                  </v-tab>
                  <v-tab ripple>
                    Anders
                  </v-tab>
                  <v-tab-item>
                    <!-- Mannen -->
                    <div class="email-text">
                      <ckeditor
                        type="classic"
                        v-model="activeCompData.receipt.emailIntro.male"
                        :upload-adapter="UploadAdapter"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                  </v-tab-item>
                  <v-tab-item>
                    <!-- Vrouwen -->
                    <div class="email-text">
                      <ckeditor
                        type="classic"
                        v-model="activeCompData.receipt.emailIntro.female"
                        :upload-adapter="UploadAdapter"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                  </v-tab-item>
                  <v-tab-item>
                    <!-- Anders -->
                    <div class="email-text">
                      <ckeditor
                        type="classic"
                        v-model="activeCompData.receipt.emailIntro.other"
                        :upload-adapter="UploadAdapter"
                        :config="editorConfig"
                      ></ckeditor>
                    </div>
                  </v-tab-item>
                </v-tabs>
                <div v-if="activeCompData.receipt">
                  <div
                    v-if="activeCompData.receipt.promotions.length == 0"
                    class="text-center"
                    style="padding: 20px 0"
                  >
                    <v-btn
                      :color="companyPrimaryColor"
                      fab
                      dark
                      @click="
                        (receiptMarketingData.dialog = true),
                          (receiptMarketingData.edit = false)
                      "
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                    <p style="padding: 5px">
                      Voeg een promotie toe om klanten extra te binden
                    </p>
                  </div>
                  <div
                    v-if="activeCompData.receipt.promotions.length > 0"
                    style="margin: 20px 0;"
                  >
                    <div
                      v-for="(promotion, index) in activeCompData.receipt
                        .promotions"
                      :key="index"
                      style="margin: 10px 0;"
                    >
                      <v-layout row style="background-color: #fff;">
                        <h3 style="padding: 10px 0 0 0;">
                          Promotie voor
                          <span v-for="(gender, index) in genders" :key="index">
                            <span v-if="gender.id == promotion.gender"
                              ><strong>{{ gender.name }}</strong></span
                            >
                          </span>
                          met
                          <strong
                            >{{ promotion.visits }}
                            <span v-if="promotion.visits == 1">bezoek</span>
                            <span v-else>bezoeken</span></strong
                          >.
                        </h3>
                        <v-flex x86> </v-flex>
                        <v-flex xs4>
                          <v-btn
                            flat
                            small
                            icon
                            color="grey"
                            @click.stop="editReceiptPromotion(index)"
                            style="float:right;"
                          >
                            <v-icon>edit</v-icon>
                          </v-btn>

                          <v-btn flat small icon style="float:right;">
                            <v-icon
                              color="grey"
                              @click="deleteReceiptPromotion(index)"
                              dark
                              >delete</v-icon
                            >
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <div
                        style="padding: 10px;"
                        :style="{ backgroundColor: promotion.color.hex }"
                      >
                        <div
                          style="font-size: 14px;"
                          :style="{ color: promotion.colorFont.hex }"
                        >
                          <strong>E-mail onderwerp: </strong
                          >{{ promotion.emailSubject }}
                        </div>
                        <div
                          style="font-size: 14px;"
                          :style="{ color: promotion.colorFont.hex }"
                        >
                          <strong>Promotie tekst </strong>
                        </div>
                        <div
                          :style="{ color: promotion.colorFont.hex }"
                          v-html="promotion.text"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <h3>Footer</h3>
                  <!-- <ckeditor :editor="editor" v-model="activeCompData.receipt.emailFooter" :config="editorConfig"></ckeditor>
                  -->

                  <ckeditor
                    type="classic"
                    v-model="activeCompData.receipt.emailFooter"
                    :upload-adapter="UploadAdapter"
                    :config="editorConfig"
                  ></ckeditor>
                </div>
              </div>

              <div class="social-preview-wrapper">
                <p>
                  <a
                    v-if="activeCompData.social.facebook == true"
                    :href="activeCompData.social.facebookUrl"
                    target="_blank"
                    class="social-icon-preview facebook"
                  >
                  </a>
                  <a
                    v-if="activeCompData.social.instagram == true"
                    :href="activeCompData.social.instagramUrl"
                    target="_blank"
                    class="social-icon-preview instagram"
                  >
                  </a>
                  <a
                    v-if="activeCompData.social.pinterest == true"
                    :href="activeCompData.social.pinterestUrl"
                    target="_blank"
                    class="social-icon-preview pinterest"
                  >
                  </a>
                  <a
                    v-if="activeCompData.social.twitter == true"
                    :href="activeCompData.social.twitterUrl"
                    target="_blank"
                    class="social-icon-preview twitter"
                  >
                  </a>
                  <a
                    v-if="activeCompData.social.googleplus == true"
                    :href="activeCompData.social.googleplusUrl"
                    target="_blank"
                    class="social-icon-preview googleplus"
                  >
                  </a>
                </p>
              </div>
            </div>
          </div>
        </v-container>
      </v-card-text>
    </v-card>

    <!-- / New Receipt Marketing Dialog \ -->
    <v-dialog
      v-model="receiptMarketingData.dialog"
      scrollable
      max-width="600px"
    >
      <v-card v-if="receiptMarketingData.dialog">
        <v-card-title
          class="pr-2"
          :style="{ backgroundColor: companyPrimaryColor }"
          style="position:relative"
        >
          <h2
            style="color:white"
            v-if="this.receiptMarketingData.edit == false"
          >
            Nieuwe promotie toevoegen
          </h2>
          <h2 style="color:white" v-else>Promotie wijzigen</h2>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!receiptMarketingData.loading"
            icon
            dark
            @click="closeMarketingDataDialog()"
          >
            <v-icon dark color="white">close</v-icon>
          </v-btn>
          <div
            v-else
            style="position: absolute; top: 50%; height: 36px; margin: -18px 0 0 0; right: 20px;"
          >
            <v-progress-circular
              :size="30"
              :width="4"
              indeterminate
              color="white"
            ></v-progress-circular>
          </div>
        </v-card-title>

        <v-alert
          class="ma-0 pa-2"
          v-if="receiptMarketingData.feedback"
          :value="true"
          type="warning"
        >
          {{ receiptMarketingData.feedback }}
        </v-alert>
        <v-divider></v-divider>

        <v-card-text>
          <v-form
            ref="receiptMarketingForm"
            v-model="receiptMarketingData.valid"
            lazy-validation
          >
            <v-select
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              v-model="receiptMarketingData.gender"
              :items="genders"
              label="Selecteer doelgroep"
              item-text="name"
              item-value="id"
              prepend-inner-icon="perm_identity"
              required
              hide-details
              :rules="requiredRules"
            >
            </v-select>

            <v-text-field
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              label="Email onderwerp"
              v-model="receiptMarketingData.emailSubject"
              prepend-inner-icon="mail_outline"
              required
              hide-details
              :rules="requiredRules"
            ></v-text-field>

            <v-text-field
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              label="Weergeven bij bezoek"
              v-model.number="receiptMarketingData.visits"
              prepend-inner-icon="cached"
              type="number"
              required
              hide-details
              :rules="requiredRules"
            ></v-text-field>

            <div class="color-box-wrapper clear" style="padding: 0 0 15px 0">
              <div class="color-boxes-icon">
                <v-icon>palette</v-icon>
              </div>
              <div class="color-boxes clear">
                <p class="ma-0">Selecteer achtergrond kleur</p>
                <div
                  class="color-box"
                  v-bind:style="{
                    backgroundColor: receiptMarketingData.color.hex,
                  }"
                  @click="receiptMarketingData.colorDialog = true"
                ></div>
              </div>
            </div>

            <div class="color-box-wrapper clear" style="padding: 0 0 15px 0">
              <div class="color-boxes-icon">
                <v-icon>palette</v-icon>
              </div>
              <div class="color-boxes clear">
                <p class="ma-0">Selecteer tekst kleur</p>
                <div
                  class="color-box"
                  v-bind:style="{
                    backgroundColor: receiptMarketingData.colorFont.hex,
                  }"
                  @click="receiptMarketingData.colorFontDialog = true"
                ></div>
              </div>
            </div>

            <div class="email-text">
              <ckeditor
                type="classic"
                v-model="receiptMarketingData.text"
                :config="editorConfig"
              ></ckeditor>
            </div>

            <v-switch
              class="ma-0 pt-4"
              label="Genereer unieke code"
              v-model="receiptMarketingData.uniqueCode"
              :color="companyPrimaryColor"
              hint="Het gebruik van een unieke code kan kans op misbruik verminderen"
              persistent-hint
            ></v-switch>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex
                xs12
                md6
                class="text-left"
                v-if="
                  $vuetify.breakpoint.name != 'sm' &&
                    $vuetify.breakpoint.name != 'xs'
                "
              >
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="closeMarketingDataDialog()"
                >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  v-if="
                    !receiptMarketingData.edit && !receiptMarketingData.loading
                  "
                  dark
                  rounded
                  :block="
                    $vuetify.breakpoint.name == 'sm' ||
                      $vuetify.breakpoint.name == 'xs'
                  "
                  :color="companySecondaryColor"
                  @click="addReceiptMarketing()"
                >
                  Promotie toevoegen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
                <v-btn
                  v-if="
                    receiptMarketingData.edit && !receiptMarketingData.loading
                  "
                  dark
                  rounded
                  :block="
                    $vuetify.breakpoint.name == 'sm' ||
                      $vuetify.breakpoint.name == 'xs'
                  "
                  :color="companySecondaryColor"
                  @click="addReceiptMarketing()"
                >
                  Wijzigingen opslaan
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- \ New Receipt Marketing Dialog / -->

    <!-- / Resend Receipt Dialog \ -->
    <v-dialog v-model="resendReceiptData.dialog" scrollable max-width="600px">
      <v-card v-if="resendReceiptData.dialog">
        <v-card-title
          class="pr-2"
          :style="{ backgroundColor: companyPrimaryColor }"
        >
          <h2 style="color:white">Bon opnieuw verzenden</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="resendReceiptData.dialog = false">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-alert
          class="ma-0 pa-2"
          v-if="resendReceiptData.feedback.message"
          :value="true"
          :type="resendReceiptData.feedback.type"
        >
          {{ resendReceiptData.feedback.message }}
        </v-alert>

        <v-divider></v-divider>

        <v-card-text>
          <v-form
            ref="resendReceiptForm"
            v-model="resendReceiptData.valid"
            lazy-validation
          >
            <v-select
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              :item-color="companyPrimaryColor"
              v-model="resendReceiptData.salon"
              :items="activeCompData.salonhubApiSettings.salons"
              label="Selecteer salon"
              item-text="name"
              item-value="salonhubid"
              prepend-inner-icon="room"
              required
              hide-details
              :rules="requiredRules"
            >
            </v-select>

            <v-text-field
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              label="Bonnnummer"
              v-model.number="resendReceiptData.receiptId"
              type="number"
              required
              :rules="requiredRules"
              prepend-inner-icon="receipt"
              hide-details
            ></v-text-field>

            <v-text-field
              class="mt-4"
              outlined
              :color="companyPrimaryColor"
              label="Email"
              v-model="resendReceiptData.email"
              :rules="emailRules"
              required
              hide-details
              prepend-inner-icon="email"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex
                xs12
                md6
                class="text-left"
                v-if="
                  $vuetify.breakpoint.name != 'sm' &&
                    $vuetify.breakpoint.name != 'xs'
                "
              >
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="resendReceiptData.dialog = false"
                >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="
                    $vuetify.breakpoint.name == 'sm' ||
                      $vuetify.breakpoint.name == 'xs'
                  "
                  :color="companySecondaryColor"
                  @click="resendReceipt()"
                >
                  Bon verzenden
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- \ Resend Receipt Dialog / -->

    <v-dialog width="225px" v-model="receiptMarketingData.colorDialog">
      <chrome-picker v-model="receiptMarketingData.color"></chrome-picker>
    </v-dialog>

    <v-dialog width="225px" v-model="receiptMarketingData.colorFontDialog">
      <chrome-picker v-model="receiptMarketingData.colorFont"></chrome-picker>
    </v-dialog>
  </div>
</template>

<script>
import db from "../firebase/init";
import firebase from "firebase/compat/app";
import { bus } from "../main";
import { Chrome } from "vue-color";
import platform from "platform";
import axios from "axios";
import moment from "moment";

export default {
  components: {
    "chrome-picker": Chrome,
  },

  name: "Receipts",
  data() {
    return {
      editorConfig: {
        toolbar: [
          "heading",
          "bold",
          "italic",
          "bulletedList",
          "numberedList",
          "|",
          "link",
          "ImageUpload",
          "|",
          "insertTable",
          "|",
          "undo",
          "redo",
        ],
        table: {
          contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"],
        },
      },
      loading: true,
      feedback: {
        type: null,
        message: null,
        show: false,
      },
      searchCompanies: "",
      activeCompData: {},
      activeCompDataOriginal: null,
      companies: [],
      activeComp: "",
      requiredRules: [(v) => !!v || "Dit veld is verplicht"],
      receiptMarketingData: {
        dialog: false,
        edit: false,
        editIndex: null,
        loading: false,
        valid: false,
        feedback: null,
        visits: 1,
        uniqueCode: false,
        gender: "male",
        color: {
          hex: "#f9f9f9",
        },
        colorFont: {
          hex: "#333333",
        },
        colorDialog: false,
        colorFontDialog: false,
        text: null,
      },
      resendReceiptData: {
        dialog: false,
        valid: false,
        feedback: {
          type: null,
          message: null,
        },
        receiptId: null,
        salon: null,
        email: null,
      },
      genders: [
        {
          name: "Mannen",
          id: "0",
        },
        {
          name: "Vrouwen",
          id: "1",
        },
        {
          name: "Anders",
          id: "2",
        },
      ],
      emailRules: [
        (v) => !!v || "E-mail is verplicht",
        (v) =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail must be valid",
      ],
    };
  },

  created() {
    this.loadUserComp();
  },

  methods: {
    UploadAdapter(loader) {
      let token = Math.random()
        .toString(36)
        .substr(2);
      this.loader = loader;

      let company = "hogans";
      let imageUrl = "";
      loader.file.then((response) => {
        this.upload = () => {
          return new Promise((resolve, reject) => {
            const file = response;
            const filename = response.name;

            const ext = filename.slice(filename.lastIndexOf("."));
            const fileUrl = "wysiwyg/" + filename + "-" + token + ext;

            let uploadTask = firebase
              .storage()
              .ref(fileUrl)
              .put(file);

            uploadTask.on(
              "state_changed",
              (taskSnapshot) => {},
              (error) => {
                console.error(error);
                reject();
              },
              () => {
                uploadTask.snapshot.ref
                  .getDownloadURL()
                  .then((url) => {
                    imageUrl = url;
                    resolve();
                  })
                  .catch((error) => {
                    reject();
                  });
              },
            );
          }).then(() => {
            return {
              default: imageUrl,
            };
          });
        };
      });
    },

    closeMarketingDataDialog() {
      this.receiptMarketingData = {
        dialog: false,
        edit: false,
        loading: false,
        editIndex: null,
        valid: false,
        feedback: null,
        visits: 1,
        uniqueCode: false,
        gender: "male",
        color: {
          hex: "#f9f9f9",
        },
        colorFont: {
          hex: "#333333",
        },
        colorDialog: false,
        colorFontDialog: false,
        text: null,
      };
    },

    addReceiptMarketing() {
      let uniquePromotion = true;
      this.receiptMarketingData.loading = true;

      new Promise((resolve, reject) => {
        let counter = 0;

        // Check if there are any promotions
        if (
          this.activeCompData.receipt.promotions.length <= 0 ||
          this.receiptMarketingData.edit == true
        ) {
          resolve();
        } else {
          // Loop through all promotions to check if the number of visits and gender are the same
          this.activeCompData.receipt.promotions.forEach((promotion) => {
            if (
              promotion.gender == this.receiptMarketingData.gender &&
              promotion.visits == this.receiptMarketingData.visits
            ) {
              uniquePromotion = false;
            }
            counter++;
            if (this.activeCompData.receipt.promotions.length == counter) {
              resolve();
            }
          });
        }
      }).then(() => {
        if (this.receiptMarketingData.edit == false) {
          if (uniquePromotion == true) {
            // This is a new promotion
            if (
              this.$refs.receiptMarketingForm.validate() &&
              this.receiptMarketingData.text
            ) {
              // All fields are filled and valid
              let newPromotion = {
                gender: this.receiptMarketingData.gender,
                color: this.receiptMarketingData.color,
                colorFont: this.receiptMarketingData.colorFont,
                emailSubject: this.receiptMarketingData.emailSubject,
                visits: this.receiptMarketingData.visits,
                text: this.receiptMarketingData.text,
                uniqueCode: this.receiptMarketingData.uniqueCode,
              };

              this.activeCompData.receipt.promotions.push(newPromotion);

              db.collection("companies")
                .doc(this.activeComp)
                .set(
                  {
                    receipt: {
                      emailIntro: this.activeCompDataOriginal.receipt
                        .emailIntro,
                      promotions: this.activeCompData.receipt.promotions,
                    },
                  },
                  { merge: true },
                )
                .then(() => {
                  db.collection("log").add({
                    time: new Date(),
                    logType: "info",
                    user: this.userFirstName + " " + this.userLastName,
                    userType: this.userRole,
                    company: this.userCompany,
                    actionType: "User Action",
                    software: String(platform.os),
                    browser: platform.name + " " + platform.version,
                    pillarrrVersion: this.$store.state.version,
                    action:
                      "Kassabon promotie toegevoegd voor: " +
                      this.activeCompData.name,
                    extra:
                      "<b>Geslacht:</b> " +
                      newPromotion.gender +
                      "<br>" +
                      "<b>Aantal bezoeken:</b> " +
                      newPromotion.visits +
                      "<br>" +
                      "<b>Onderwerp:</b> " +
                      newPromotion.emailSubject +
                      "<br>" +
                      "<b>Tekst:</b> " +
                      newPromotion.text +
                      "<br>" +
                      "<b>Kleur:</b> " +
                      newPromotion.color.hex +
                      "<br>" +
                      "<b>Tekstkleur:</b> " +
                      newPromotion.colorFont.hex,
                  });
                })
                .then(() => {
                  this.receiptMarketingData = {
                    dialog: false,
                    edit: false,
                    loading: false,
                    editIndex: null,
                    valid: false,
                    feedback: null,
                    visits: 1,
                    uniqueCode: false,
                    gender: "male",
                    color: {
                      hex: "#f9f9f9",
                    },
                    colorFont: {
                      hex: "#333333",
                    },
                    colorDialog: false,
                    colorFontDialog: false,
                    text: null,
                  };
                  this.activeCompDataOriginal.receipt.promotions = _.cloneDeep(
                    this.activeCompData.receipt.promotions,
                  );
                  const toast = this.$swal.mixin({
                    toast: true,
                    position: "top",
                    showConfirmButton: false,
                    timer: 5000,
                  });

                  toast({
                    type: "success",
                    title: `De promotie is succesvol toegevoegd.`,
                  });
                });
            } else {
              // Not all fields are filled or valid
              this.receiptMarketingData.loading = false;
              this.receiptMarketingData.feedback =
                "Vul alle velden in om de promotie op te slaan";
            }
          } else {
            // Promotion allready exists
            this.receiptMarketingData.loading = false;
            this.receiptMarketingData.feedback =
              "Er bestaat al een promotie voor deze doelgroep en aantal bezoeken.";
          }
        } else {
          // This is a existing promotions that's beeing edited
          if (
            this.$refs.receiptMarketingForm.validate() &&
            this.receiptMarketingData.text
          ) {
            // All fields are filled and valid
            this.activeCompData.receipt.promotions[
              this.receiptMarketingData.editIndex
            ].visits = _.cloneDeep(this.receiptMarketingData.visits);
            this.activeCompData.receipt.promotions[
              this.receiptMarketingData.editIndex
            ].gender = _.cloneDeep(this.receiptMarketingData.gender);
            this.activeCompData.receipt.promotions[
              this.receiptMarketingData.editIndex
            ].text = _.cloneDeep(this.receiptMarketingData.text);
            this.activeCompData.receipt.promotions[
              this.receiptMarketingData.editIndex
            ].emailSubject = _.cloneDeep(
              this.receiptMarketingData.emailSubject,
            );
            this.activeCompData.receipt.promotions[
              this.receiptMarketingData.editIndex
            ].color = _.cloneDeep(this.receiptMarketingData.color);
            this.activeCompData.receipt.promotions[
              this.receiptMarketingData.editIndex
            ].colorFont = _.cloneDeep(this.receiptMarketingData.colorFont);
            this.activeCompData.receipt.promotions[
              this.receiptMarketingData.editIndex
            ].uniqueCode = _.cloneDeep(this.receiptMarketingData.uniqueCode);

            db.collection("companies")
              .doc(this.activeComp)
              .set(
                {
                  receipt: {
                    emailIntro: this.activeCompDataOriginal.receipt.emailIntro,
                    promotions: this.activeCompData.receipt.promotions,
                  },
                },
                { merge: true },
              )
              .then(() => {
                db.collection("log").add({
                  time: new Date(),
                  logType: "info",
                  user: this.userFirstName + " " + this.userLastName,
                  userType: this.userRole,
                  company: this.userCompany,
                  actionType: "User Action",
                  software: String(platform.os),
                  browser: platform.name + " " + platform.version,
                  pillarrrVersion: this.$store.state.version,
                  action:
                    "Kassabon promotie gewijzigd voor: " +
                    this.activeCompData.name,
                  extra:
                    "<b>ORIGINELE PROMOTIE:</b> " +
                    "<br>" +
                    "<b>Geslacht:</b> " +
                    this.activeCompDataOriginal.receipt.promotions[
                      this.receiptMarketingData.editIndex
                    ].gender +
                    "<br>" +
                    "<b>Aantal bezoeken:</b> " +
                    this.activeCompDataOriginal.receipt.promotions[
                      this.receiptMarketingData.editIndex
                    ].visits +
                    "<br>" +
                    "<b>Tekst:</b>" +
                    this.activeCompDataOriginal.receipt.promotions[
                      this.receiptMarketingData.editIndex
                    ].text +
                    "<br>" +
                    "<b>Kleur: </b>" +
                    this.activeCompDataOriginal.receipt.promotions[
                      this.receiptMarketingData.editIndex
                    ].color.hex +
                    "<br><br>" +
                    "<b>AANGEPAST:</b> " +
                    "<br>" +
                    "<b>Geslacht:</b> " +
                    this.receiptMarketingData.gender +
                    "<br>" +
                    "<b>Aantal bezoeken:</b> " +
                    this.receiptMarketingData.visits +
                    "<br>" +
                    "<b>Onderwerp:</b>" +
                    this.receiptMarketingData.emailSubject +
                    "<br>" +
                    "<b>Tekst:</b>" +
                    this.receiptMarketingData.text +
                    "<br>" +
                    "<b>Kleur: </b>" +
                    this.receiptMarketingData.color.hex +
                    "<br>" +
                    "<b>Tekstleur: </b>" +
                    this.receiptMarketingData.colorFont.hex +
                    "<br>" +
                    "<b>Unieke code: </b>" +
                    this.receiptMarketingData.uniqueCode,
                });
              })
              .then(() => {
                this.receiptMarketingData = {
                  dialog: false,
                  edit: false,
                  loading: false,
                  editIndex: null,
                  valid: false,
                  feedback: null,
                  visits: 1,
                  uniqueCode: false,
                  gender: "male",
                  color: {
                    hex: "#f9f9f9",
                  },
                  colorFont: {
                    hex: "#333333",
                  },
                  colorDialog: false,
                  colorFontDialog: false,
                  text: null,
                };
                const toast = this.$swal.mixin({
                  toast: true,
                  position: "top",
                  showConfirmButton: false,
                  timer: 5000,
                });

                toast({
                  type: "success",
                  title: `De promotie is succesvol gewijzigd.`,
                });
                this.activeCompDataOriginal.receipt.promotions = _.cloneDeep(
                  this.activeCompData.receipt.promotions,
                );
              })
              .catch((error) => {
                console.error("Error bij opslaan promotie: ", error);
                this.receiptMarketingData.loading = false;
                this.receiptMarketingData.feedback =
                  "Opslaan is niet gelukt. Probeer het opnieuw.";
              });
          } else {
            // Not all fields are filled or valid
            this.receiptMarketingData.loading = false;
            this.receiptMarketingData.feedback =
              "Vul alle velden in om de promotie te wijzigen";
          }
        }
      });
    },

    resendReceipt() {
      this.resendReceiptData.feedback = {
        type: null,
        message: null,
      };
      if (this.$refs.resendReceiptForm.validate()) {
        // All fields are filled and valid
        axios
          .get(
            "http://149.210.249.98:9989/verstuurbon?compsalonhub=" +
              this.activeCompData.salonhubApiSettings.customer +
              "&company=" +
              this.activeCompData.id +
              "&salon=" +
              this.resendReceiptData.salon +
              "&email=" +
              this.resendReceiptData.email +
              "&bonnr=" +
              this.resendReceiptData.receiptId,
          ) // Haalt user rechten binnen
          .then((response) => {
            this.resendReceiptData = {
              dialog: false,
              salon: null,
              feedback: {
                type: null,
                message: null,
              },
              receiptId: null,
              email: null,
            };
            this.feedback = {
              type: "succes",
              message: "Bon is succesvol verzonden",
              show: true,
            };
            setTimeout(() => {
              this.feedback.show = false;
            }, 5000);
          })

          .catch((error) => {
            console.error("Error - versturen van bon", error);
            this.resendReceiptData.feedback.type = "error";
            this.resendReceiptData.feedback.message =
              "Bon versturen is niet gelukt. Probeer opnieuw";
            // if (401 === error.response.status) {
            //   console.error("401 error bij versturen van bon", error);
            // } else {
            //   console.error("Error bij versturen van bon", error);
            // }
          });
      } else {
        // Not all fields are filled or valid
        this.resendReceiptData.feedback.type = "warning";
        this.resendReceiptData.feedback.message =
          "Vul alle velden in om de bon te verzenden";
      }
    },

    deleteReceiptPromotion(index) {
      let deletedPromotion = this.activeCompData.receipt.promotions[index];
      this.activeCompData.receipt.promotions.splice(index, 1);

      db.collection("companies")
        .doc(this.activeComp)
        .set(
          {
            receipt: {
              emailIntro: this.activeCompDataOriginal.receipt.emailIntro,
              promotions: this.activeCompData.receipt.promotions,
            },
          },
          { merge: true },
        )
        .then(() => {
          db.collection("log").add({
            time: new Date(),
            logType: "info",
            user: this.userFirstName + " " + this.userLastName,
            userType: this.userRole,
            company: this.userCompany,
            actionType: "User Action",
            software: String(platform.os),
            browser: platform.name + " " + platform.version,
            pillarrrVersion: this.$store.state.version,
            action:
              "Kassabon promotie verwijderd voor: " + this.activeCompData.name,
            extra:
              "<b>Geslacht:</b> " +
              deletedPromotion.gender +
              "<br>" +
              "<b>Aantal bezoeken:</b> " +
              deletedPromotion.visits +
              "<br>" +
              "<b>Tekst:</b> " +
              deletedPromotion.text +
              "<br>" +
              "<b>Kleur:</b> " +
              deletedPromotion.color.hex +
              "<br>" +
              "<b>Tekstkleur:</b> " +
              deletedPromotion.colorFont.hex,
          });
        })
        .then(() => {
          this.activeCompDataOriginal.receipt.promotions = _.cloneDeep(
            this.activeCompData.receipt.promotions,
          );
          const toast = this.$swal.mixin({
            toast: true,
            position: "top",
            showConfirmButton: false,
            timer: 5000,
          });

          toast({
            type: "success",
            title: `De promotie is succesvol verwijderd.`,
          });
        })
        .catch((error) => {
          console.error("Error bij verwijderen promotie: ", error);
          this.feedback = {
            type: "error",
            message:
              "Promotie verwijderen is niet gelukt. Probeer het opnieuw.",
            show: true,
          };
          setTimeout(() => {
            this.feedback.show = false;
          }, 5000);
        });
    },

    editReceiptPromotion(index) {
      this.receiptMarketingData = {
        dialog: true,
        edit: true,
        loading: false,
        editIndex: index,
        valid: false,
        feedback: null,
        uniqueCode: this.activeCompData.receipt.promotions[index].uniqueCode,
        visits: this.activeCompData.receipt.promotions[index].visits,
        emailSubject: this.activeCompData.receipt.promotions[index]
          .emailSubject,
        gender: this.activeCompData.receipt.promotions[index].gender,
        color: this.activeCompData.receipt.promotions[index].color,
        colorFont: this.activeCompData.receipt.promotions[index].colorFont,
        colorDialog: false,
        colorFontDialog: false,
        text: this.activeCompData.receipt.promotions[index].text,
      };
    },

    updateReceiptEmail() {
      if (
        this.activeCompData.receipt.subjectDefaultInvoice &&
        this.activeCompData.receipt.emailIntro.male &&
        this.activeCompData.receipt.emailIntro.female &&
        this.activeCompData.receipt.emailIntro.other
      ) {
        // All fields are filled and valid
        db.collection("companies")
          .doc(this.activeComp)
          .set(
            {
              receipt: this.activeCompData.receipt,
            },
            { merge: true },
          )
          .then(() => {
            db.collection("log").add({
              time: new Date(),
              logType: "info",
              user: this.userFirstName + " " + this.userLastName,
              userType: this.userRole,
              company: this.userCompany,
              actionType: "User Action",
              software: String(platform.os),
              browser: platform.name + " " + platform.version,
              pillarrrVersion: this.$store.state.version,
              action:
                "Kassabon e-mail gewijzigd voor: " + this.activeCompData.name,
              extra:
                "<b>ORIGINELE E-MAILTEKST:</b> " +
                "<br>" +
                "<b>Mannen:</b> " +
                this.activeCompDataOriginal.receipt.emailIntro.male +
                "<br>" +
                "<b>Vrouwen:</b> " +
                this.activeCompDataOriginal.receipt.emailIntro.female +
                "<b>Anders:</b>" +
                this.activeCompDataOriginal.receipt.emailIntro.other +
                "<br><br>" +
                "<b>AANGEPAST E-MAILTEKST:</b> " +
                "<br>" +
                "<b>Mannen:</b> " +
                this.activeCompData.receipt.emailIntro.male +
                "<br>" +
                "<b>Vrouwen:</b> " +
                this.activeCompData.receipt.emailIntro.female +
                "<b>Anders:</b>" +
                this.activeCompData.receipt.emailIntro.other,
            });
          })
          .then(() => {
            this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
            const toast = this.$swal.mixin({
              toast: true,
              position: "top",
              showConfirmButton: false,
              timer: 5000,
            });

            toast({
              type: "success",
              title: `De wijzigingen zijn succesvol opgeslagen.`,
            });
          })
          .catch((error) => {
            console.error("Error bij wijzigen kassabon: ", error);
            this.feedback =
              "Opslaan van de wijzigingen is niet gelukt. Probeer het opnieuw.";
          });
      } else {
        // Not all fields are filled or valid
        this.feedback = {
          type: "warning",
          message: "Vul alle velden in om op te slaan",
          show: true,
        };
        setTimeout(() => {
          this.feedback.show = false;
        }, 5000);
      }
    },

    loadUserComp() {
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0;

      new Promise((resolve, reject) => {
        this.userCompanies.forEach((company) => {
          db.collection("companies")
            .doc(company)
            .get()
            .then((doc) => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++;
              if (counter == this.userCompanies.length) {
                resolve();
              }
            });
        });
      }).then(() => {
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if (this.userRole == "superadmin") {
          // Super Admins have access to multiple companies
          let selectedCompany = window.localStorage.getItem("selectedCompany");

          // Check if a selected company is set in the Local Storage
          if (selectedCompany) {
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, {
              id: selectedCompany,
            });

            // Selected company is an option, set activeComp
            if (selectedCompanyIndex >= 0) {
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            }
            // Selected company is no option, set first company as activeComp
            else {
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem(
                "selectedCompany",
                this.companies[0].id,
              );
              this.loadActiveCompData();
            }
          }
          // No selected company is set
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem(
              "selectedCompany",
              this.companies[0].id,
            );
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
        }
      });
    },

    loadActiveCompData() {
      console.log("loadActiveCompData");
      this.loading = true;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem("selectedCompany", this.activeComp);
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
          this.selectedLanguage = this.activeCompDataOriginal.languages[0];
        })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          console.log("Error getting document:", error);
        });
    },
  },

  computed: {
    reviewsPackage() {
      let packageStatus = {
        type: "inactive",
        days: 0,
      };

      if (
        this.activeCompData.packages &&
        this.activeCompData.packages.length > 0 &&
        _.indexOf(this.activeCompData.packages, "customerjourney") >= 0
      ) {
        packageStatus.type = "active";
      } else {
        // Package not purchased, check for active trial
        if (
          this.activeCompData.trials &&
          this.activeCompData.trials.length > 0
        ) {
          this.activeCompData.trials.forEach((trailPackage) => {
            if (trailPackage.id == "customerjourney") {
              // Trial found, check if trialperiod is still active
              if (
                moment(trailPackage.trialStartDate).add(
                  trailPackage.trialDays,
                  "days",
                ) > moment()
              ) {
                packageStatus.type = "trial";
                packageStatus.days = moment(trailPackage.trialStartDate)
                  .add(trailPackage.trialDays, "days")
                  .diff(moment(), "days");
              }
            }
          });
        }
      }
      return packageStatus;
    },

    demoMode() {
      return this.$store.state.demoMode;
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    filteredCompanies() {
      if (this.searchCompanies && this.searchCompanies.length > 0) {
        return this.companies.filter((company) => {
          return company.name
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies;
      }
    },
    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
    changed() {
      if (this.activeCompData.receipt) {
        if (
          _.isEqual(
            this.activeCompData.receipt.emailIntro,
            this.activeCompDataOriginal.receipt.emailIntro,
          ) == false ||
          _.isEqual(
            this.activeCompData.receipt.emailFooter,
            this.activeCompDataOriginal.receipt.emailFooter,
          ) == false ||
          _.isEqual(
            this.activeCompData.receipt.subjectDefaultInvoice,
            this.activeCompDataOriginal.receipt.subjectDefaultInvoice,
          ) == false
        ) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
  },
};
</script>
